import { Component, Element, h, Host, Prop, State } from '@stencil/core'

import Helpers from '../../../utils/helpers'

/**
 * ## Design System
 *
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/menu?tab=designer).
 *
 * @slot default - Slot para logo ou conteúdo que substitui a imagem padrão.
 */
@Component({
  tag: 'br-menu-logo',
  styleUrl: 'menu-logo.scss',
  shadow: true,
  formAssociated: true,
})
export class MenuLogo {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrMenuLogoElement

  /**
   * ID personalizado para o elemento, útil para acessibilidade e identificação única.
   * Se não for fornecido, um ID único será gerado automaticamente.
   */
  @Prop({ reflect: true }) readonly customId: string = Helpers.generateUniqueId()

  /**
   * URL da imagem
   */
  @Prop({ reflect: true }) src!: string

  /**
   * Texto alternativo da imagem
   */
  @Prop({ reflect: true }) alt?: string

  /**
   * Largura da imagem (com unidade, ex: '100px', '50%')
   */
  @Prop({ reflect: true }) width?: string

  /**
   * Altura da imagem (com unidade, ex: '80px', 'auto')
   */
  @Prop({ reflect: true }) height?: string

  /**
   * Estado para controlar se a imagem falhou ao carregar
   */
  @State() hasError: boolean = false

  /**
   * Manipula erros no carregamento da imagem
   */
  private handleError = () => {
    this.hasError = true
    console.error(`Erro ao carregar a imagem do logo. Verifique se o caminho está correto: ${this.src}`)
    console.debug('Caminho absoluto tentado:', new URL(this.src, window.location.href).href)
  }

  private handleLoad = () => {
    this.hasError = false
  }

  render() {
    const imageStyle = {
      width: this.width,
      height: this.height,
    }

    return (
      <Host>
        <div class="br-menu-logo" id={this.customId}>
          <slot>
            {this.src && (
              <img
                src={this.src}
                alt={this.alt || 'Logo'}
                style={imageStyle}
                onError={this.handleError}
                onLoad={this.handleLoad}
              />
            )}
          </slot>
        </div>
      </Host>
    )
  }
}
